export { PericlesProvider, usePericlesClient } from './core/PericlesProvider';
export type { PericlesClientConfig, PericlesProviderProps } from './core/PericlesProvider';

export { AdminShell } from './layout/AdminShell';
export type { AdminShellProps } from './layout/AdminShell';
export { SidebarNav } from './layout/SidebarNav';
export type { SidebarNavProps } from './layout/SidebarNav';

export { useEntityList } from './data/useEntityList';
export type { UseEntityListParams, UseEntityListResult } from './data/useEntityList';
export { useEntityDetail } from './data/useEntityDetail';
export type { UseEntityDetailParams, UseEntityDetailResult } from './data/useEntityDetail';
export { useCreateEntity } from './data/useCreateEntity';
export type { UseCreateEntityParams, UseCreateEntityResult } from './data/useCreateEntity';
export { useUpdateEntity } from './data/useUpdateEntity';
export type { UseUpdateEntityParams, UseUpdateEntityResult } from './data/useUpdateEntity';
export { useDeleteEntity } from './data/useDeleteEntity';
export type { UseDeleteEntityParams, UseDeleteEntityResult } from './data/useDeleteEntity';
export { useEntityDelete } from './data/useEntityDelete';
export type { UseEntityDeleteParams, UseEntityDeleteResult } from './data/useEntityDelete';

export { Card } from './ui/Card';
export type { CardProps } from './ui/Card';

export { PageHeader } from './ui/PageHeader';
export type { PageHeaderProps } from './ui/PageHeader';

export { Badge } from './ui/Badge';
export type { BadgeProps } from './ui/Badge';

export { EmptyState } from './ui/EmptyState';
export type { EmptyStateProps } from './ui/EmptyState';
export {
  Dialog,
  DialogTrigger,
  DialogPortal,
  DialogClose,
  DialogOverlay,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from './ui/Dialog';
export { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/Tabs';

export { DataTable } from './ui/DataTable';
export type { DataTableColumn, DataTableProps, TextAlign } from './ui/DataTable';

export { Form } from './ui/Form';
export type { FormProps } from './ui/Form';
export { FormSection } from './ui/FormSection';
export type { FormSectionProps } from './ui/FormSection';
export { FormField } from './ui/FormField';
export type { FormFieldProps } from './ui/FormField';
export { renderFieldInput } from './ui/FormFieldInputFactory';
export type { FieldInputProps } from './ui/FormFieldInputFactory';
export { TextInput } from './ui/TextInput';
export type { TextInputProps } from './ui/TextInput';
export { NumberInput } from './ui/NumberInput';
export type { NumberInputProps } from './ui/NumberInput';
export { DateInput } from './ui/DateInput';
export type { DateInputProps } from './ui/DateInput';
export { SelectInput } from './ui/SelectInput';
export type { SelectInputProps } from './ui/SelectInput';
export { CheckboxInput } from './ui/CheckboxInput';
export type { CheckboxInputProps } from './ui/CheckboxInput';

export { EntityListScreen } from './screens/EntityListScreen';
export type { EntityListScreenProps } from './screens/EntityListScreen';
export { EntityDetailScreen } from './screens/EntityDetailScreen';
export type { EntityDetailScreenProps } from './screens/EntityDetailScreen';
export { EntityFormScreen } from './screens/EntityFormScreen';
export type { EntityFormMode, EntityFormScreenProps } from './screens/EntityFormScreen';
export { EntityCreateScreen } from './screens/EntityCreateScreen';
export type { EntityCreateScreenProps } from './screens/EntityCreateScreen';
export { EntityEditScreen } from './screens/EntityEditScreen';
export type { EntityEditScreenProps } from './screens/EntityEditScreen';

export type {
  SortDirection,
  UiAppSpec,
  UiNavSection,
  UiNavItem,
  UiEntitySpec,
  UiEntityListConfig,
  UiListColumnSpec,
  UiEntityDetailConfig,
  UiDetailSectionSpec,
  UiDetailFieldSpec,
  UiFieldEditorType,
  UiFormFieldOption,
  UiFormFieldSpec,
  UiFormSectionSpec,
  UiEntityFormSpec,
  UiScreenSpec,
  UiListFilterSpec,
} from './config/uiSpec';

export type {
  ProjectWorkItem,
  ProjectWorkItemStatus,
  CreateProjectWorkItemInput,
  UpdateProjectWorkItemInput,
} from './types/workItems';

export type {
  ProjectMeeting,
  ProjectMeetingQuestion,
  ProjectMeetingStatus,
  CreateProjectMeetingInput,
  UpdateProjectMeetingInput,
} from './types/meetings';

export { buildSidebarNavFromUiSpec } from './config/navigation';
export type { SidebarNavItem } from './config/navigation';
